import React, { useEffect, useState } from "react"
import { Footer, Header, LeftNavigation } from "../controller/BaseToolUI"
import { Player } from "@lottiefiles/react-lottie-player"
import { Wtd } from "../view/Wtd/App"
import { WhatsAppChatButton } from "../view/WhatsappChatButton/App"
import { WhatsappLinkGenerator } from "../view/WhatsappLinkGenerator/App"
import { MessageTemplate } from "../view/MessageTemplate/MessageTemplate"
import { PricingCalculator } from "../view/Calculator/PricingCalculator"
import { LoginValidate } from "../controller/caller"
import { ChangePassword, EmailVerification, ForgotPassword, Login, OtpVerification, PaymentFailed, PaymentSuccess, Signup, WhatsAppVerification } from "../view/template"
import { SignupSuccess } from "../view/Registration/SignupSuccess"
import { Box } from "@mui/material"
import { Dashboard } from "../view/Dashboard/App"
import { Chat } from "../view/Chat/App"
import { WtTheme } from "../controller/theme"
import { WtString } from "../constants/strings"
import { NoChannelDialog } from "../controller/BaseTool"
import { Contacts } from "../view/Contacts/App"
import { Broadcast } from "../view/Broadcast/App"
import CreateCampaign from "../view/Broadcast/CreateCampaign"
import { ChatbotListUI } from "../view/BotEditor/ChatbotList"
import App from "../view/BotEditor/App"
import { Settings } from "../view/Settings/App"
import { BusinessInformation } from "../view/Settings/BusinessInfo"
import { ChannelsApp } from "../view/Settings/Channels"
import { Agents } from "../view/Settings/Agents"
import { Labels } from "../view/Settings/Labels"
import { CustomFields } from "../view/Settings/CustomFields"
import { QuickReply } from "../view/Settings/QuickReply"
import { Templates } from "../view/Settings/Template"
import { MediaFiles } from "../view/Settings/MediaFiles"
import { ApiIntegration } from "../view/Settings/ApiIntegration"
import { AppIntegration } from "../view/Settings/AppIntegration"
import { Profile } from "../view/UserProfile/Profile"
import { PasswordChange } from "../view/UserProfile/Password"
import { useWindowDimensions } from "../view/useWindowDimensions"
import { PlanSubscription } from "../view/Payment/PlanSubscription"
import { AddOns } from "../view/Payment/AddOns"
import { Summary } from "../view/Payment/Summary"
import { Analytics } from "../view/Analytics/ui"
import { WtDimen } from "../constants/dimens"
import { LoginDialog } from "../basetool/dialogs"
import { WtUrl } from "../constants/urls"
import { FeaturedChatbotTemplates } from "../view/FeaturedChatBotTemplates/FeaChatBotTemp"

export const WTDUIAdapter = () => {
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "smooth" }) }, [])
  return (
    <>
      <Wtd />
      <Footer />
    </>
  )
}

export const WhatsappChatButtonUIAdapter = () => {
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "smooth" }) }, [])
  return (
    <>
      <Header />
      <WhatsAppChatButton />
      <Footer />
    </>
  )
}

export const WhatsappLinkGeneratorAdapter = () => {
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "smooth" }) }, [])
  return (
    <>
      <Header />
      <WhatsappLinkGenerator />
      <Footer />
    </>
  )
}

export const WhatsappMessageTemplate = () => {
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "smooth" }) }, [])
  return (
    <>
      {/* <Header /> */}
      <MessageTemplate />
      {/* <Footer /> */}
    </>
  )
}

export const WhatstoolProcongCalulator = () => {
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "smooth" }) }, [])
  return (
    <>
      <Header />
      <PricingCalculator />
      <Footer />
    </>
  )
}


export const LoginLoaderUIAdapter = () => {
  return (
    <Player autoplay loop src="https://assets2.lottiefiles.com/packages/lf20_zffo1hqh.json" style={{ width: "600px" }} className="items-lottie mt-3"> </Player>
  )
}

// Login UI Adapter
export const LoginUIAdapter = () => {
  if (LoginValidate()) { window.location.href = WtUrl.dashboardUrl }
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "smooth" }) }, [])
  return (
    <>
      <Login />
    </>
  )
}
export const ChangePasswordUIAdapter = () => {
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "smooth" }) }, [])
  return (
    <>
      <ChangePassword />
    </>
  )
}
export const ForgotPasswordUIAdapter = () => {
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "smooth" }) }, [])
  return (
    <>
      <ForgotPassword />
    </>
  )
}

export const SignupUIAdapter = () => {
  if (LoginValidate()) { window.location.href = WtUrl.dashboardUrl }
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "smooth" }) }, [])
  return (
    <>
      <Signup />
    </>
  )
}
export const SignupSuccessUIAdapter = () => { return <SignupSuccess /> }
export const EmailVerificationUIAdapter = () => { return <EmailVerification /> }
export const WhatsAppVerificationUIAdapter = () => { return <WhatsAppVerification /> }
export const OtpVerificationUIAdapter = () => { return <OtpVerification /> }
// End of Login UI Adapter

// Dashboard UI Adapter
export const DashboardUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}><Dashboard /></Box>
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
// End of Dashboard UI Adapter

// Chat UI Adapter
export const ChatUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => { setOpenDialog({ open: true }) }
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  const [openNoChannelDialog, setOpenNoChannelDialog] = useState({ open: false })
  useEffect(() => {
    if (!localStorage.getItem("c1") || localStorage.getItem("c1") === "" || localStorage.getItem("c1") === "undefined") {
      setOpenNoChannelDialog({ open: true })
    }
  }, [])
  return (
    <Box sx={{ display: "flex" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}>
        {
          localStorage.getItem("c1") && localStorage.getItem("c1") !== "" && localStorage.getItem("c1") !== "undefined"
            ? <Chat /> : <img src={WtTheme.chat_default_url} style={{ width: "100%", height: "100vh" }} alt={WtString.SiteName} />
        }
      </Box>
      <NoChannelDialog open={openNoChannelDialog.open} onClose={openNoChannelDialog.onClose} />
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
// End of Chat UI Adapter

// Contacts UI Adapter
export const ContactsUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}><Contacts /></Box>
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
// End of Contacts UI Adapter

// Broadcast UI Adapter
export const BroadcastUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })

  const [openNoChannelDialog, setOpenNoChannelDialog] = useState({ open: false })
  useEffect(() => {
    if (!localStorage.getItem("c1") || localStorage.getItem("c1") === "" || localStorage.getItem("c1") === "undefined") setOpenNoChannelDialog({ open: true })
  }, [])
  return (
    <Box sx={{ display: "flex" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}>
        {
          localStorage.getItem("c1") && localStorage.getItem("c1") !== "" && localStorage.getItem("c1") !== "undefined"
            ? <Broadcast /> : <img src={WtTheme.campaign_default_url} style={{ width: "100%", height: "100vh" }} alt={WtTheme.SiteName} />
        }
      </Box>
      <NoChannelDialog open={openNoChannelDialog.open} onClose={openNoChannelDialog.onClose} />
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
export const CreateCampaignUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}><CreateCampaign /></Box>
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
// End of Broadcast UI Adapter

// Chatbot UI Adapter
export const ChatbotListUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })

  const [openNoChannelDialog, setOpenNoChannelDialog] = useState({ open: false })
  useEffect(() => {
    if (!localStorage.getItem("c1") || localStorage.getItem("c1") === "" || localStorage.getItem("c1") === "undefined") setOpenNoChannelDialog({ open: true })
  }, [])
  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}>
        {
          localStorage.getItem("c1") && localStorage.getItem("c1") !== "" && localStorage.getItem("c1") !== "undefined"
            ? <ChatbotListUI /> : <img src={WtTheme.chatbot_default_url} style={{ width: "100%", height: "100vh" }} alt={WtTheme.SiteName} />
        }
      </Box>
      <NoChannelDialog open={openNoChannelDialog.open} onClose={openNoChannelDialog.onClose} />
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
export const BuildChatbotsUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}><App /></Box>
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
// Chatbot UI Adapter

// Setting UI Adapter
export const SettingsUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}><Settings /></Box>
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
export const BusinessInformationUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}><BusinessInformation /></Box>
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
export const ChannelsUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}><ChannelsApp /></Box>
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
export const AgentsUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}><Agents /></Box>
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
export const LabelsUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}><Labels /></Box>
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
export const CustomFieldsUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}><CustomFields /></Box>
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
export const QuickReplyUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}><QuickReply /></Box>
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
export const TemplatesUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}><Templates /></Box>
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
export const MediaFilesUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}><MediaFiles /></Box>
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
export const APIIntegrationUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}><ApiIntegration /></Box>
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
export const APPIntegrationUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}><AppIntegration /></Box>
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
// End of Setting UI Adapter

// Profile UI Adapter
export const ProfileUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}><Profile /></Box>
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
export const ProfileChangePasswordUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}><PasswordChange /></Box>
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
export const PaymentPlanSubscriptionUIAdapter = () => {
  const { width } = useWindowDimensions()

  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      {
        (width <= 780) ?
          <Box sx={{ flexGrow: 1, p: 0 }}><PlanSubscription /></Box>
          :
          <>
            <LeftNavigation />
            <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}><PlanSubscription /></Box>
          </>
      }
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
export const PaymentAddOnsUIAdapter = () => {
  const { width } = useWindowDimensions()
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      {
        (width <= 780) ?
          <Box sx={{ flexGrow: 1, p: 0 }}><AddOns /></Box>
          :
          <>
            <LeftNavigation />
            <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}><AddOns /></Box>
          </>
      }
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
export const PaymentSummaryUIAdapter = () => {
  const { width } = useWindowDimensions()
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      {
        (width <= 780) ?
          <Box sx={{ flexGrow: 1, p: 0 }}><Summary /></Box>
          :
          <>
            <LeftNavigation />
            <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}>
              <Summary />
            </Box>
          </>

      }
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
// End of Profile UI Adapter

// Payment Success and Failure Adapter
export const PaymentSuccessUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex" }}>
      <PaymentSuccess />
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
export const PaymentFailedUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })
  return (
    <Box sx={{ display: "flex" }}>
      <PaymentFailed />
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}
// End of Payment Success and Failure Adapter

export const AnalyticsUIAdapter = () => {
  const [openDialog, setOpenDialog] = useState({ open: false })
  const openDialogBox = () => setOpenDialog({ open: true })
  useEffect(() => { if (!LoginValidate()) openDialogBox() })

  const [openNoChannelDialog, setOpenNoChannelDialog] = useState({ open: false })
  useEffect(() => {
    if (!localStorage.getItem("c1") || localStorage.getItem("c1") === "" || localStorage.getItem("c1") === "undefined") setOpenNoChannelDialog({ open: true })
  }, [])
  return (
    <Box sx={{ display: "flex" }}>
      <LeftNavigation />
      <Box sx={{ flexGrow: 1, p: 0, ml: WtDimen.leftSidebarMargin }}>
        {
          localStorage.getItem("c1") && localStorage.getItem("c1") !== "" && localStorage.getItem("c1") !== "undefined"
            ? <Analytics /> : <img src={WtTheme.analytics_default_url} style={{ width: "100%", height: "100vh" }} alt={WtTheme.SiteName} />
        }
      </Box>
      <NoChannelDialog open={openNoChannelDialog.open} onClose={openNoChannelDialog.onClose} />
      <LoginDialog open={openDialog.open} onClose={openDialog.onClose} />
    </Box>
  )
}




// Featured Chatbot Template
export const FeaturedChatBotTemplateUIAdapter = () => {
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "smooth" }) }, [])
  return (
    <>
      <Header />
      <FeaturedChatbotTemplates />
      <Footer />
    </>
  )
}
// End of Featured Chatbot Template
